// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"Banner_bannerWrapper__2HYzy"};